import { render, staticRenderFns } from "./PublicacionActComponent.vue?vue&type=template&id=7011f61a&scoped=true&"
import script from "./PublicacionActComponent.vue?vue&type=script&lang=ts&"
export * from "./PublicacionActComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PublicacionActComponent.vue?vue&type=style&index=0&id=7011f61a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7011f61a",
  null
  
)

export default component.exports